module.exports = __webpack_public_path__ + "static/media/7-3.8f938944.mp3";